export const DATE_FORMAT = {
	day: 'numeric',
	month: 'short',
	year: 'numeric',
	hour: 'numeric',
	minute: 'numeric',
} as const;
